module.exports = __webpack_public_path__ + "static/media/S3N1-3.d0db2297.svg";